/* eslint-disable */
/**
 * * This file was automatically generated by react-scripts-trackman codegen.
 * * DO NOT MODIFY IT BY HAND. Instead, modify endpoint definitions in backend,
 * * start backend to regenerate swagger.json, and run react-scripts-trackman codegen
 * * to regenerate this file.
 * *
 * * If you find errors in this file, do the following (in order):
 * * 1. Check Swagger configuration in backend (often SwaggerResponse is wrongly defined)
 * * 2. Check backend type and controller definitions
 * * 3. Check if the endpoint is properly defined in consumedEndpoints.json
 * * 4. Report the issue to react-scripts-trackman maintainers (mga@trackman.com)
 */

import { PlaySetup } from '../types/CodegenSetupTypes';
import { AxiosInstance } from 'axios';
import { Result } from '../types/CodegenResult';

export class SetupService {
  private axiosInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  postSetup = async (requestBody: PlaySetup) => {
    const response = await this.axiosInstance.post<Result<undefined>>(`/api/Setup`, requestBody);
    if (!response) throw Error('No response');
    if (response.status === 200) return 'Success';
    if (response.status === 401) throw Error('Unauthorized');
    if (response.status === 403) throw Error('Forbidden');
    if (response.status === 500) throw Error('Internal Server Error');
    throw Error('Unknown error');
  };
}

export default SetupService;
